import { createRoot } from 'react-dom/client';

import './_shared/styles/index.css';

import App from './_app';

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
  <App />
  // {/* </StrictMode> */}
);
